import useNotifications from '@anm/hooks/useNotifications';

import { SaveVideoDataState } from '../../../../store/modules/hostedVideo';
import NOTIFICATION_MESSAGES from '../notificationMessages';

const useVideoDataNotifications = (entity: SaveVideoDataState) => {
  const { notifications } = useNotifications({
    ...entity,
    ...NOTIFICATION_MESSAGES
  });

  return notifications;
};

export default useVideoDataNotifications;
